module.exports = __webpack_public_path__ + "img/Standard Bank.8e06cca6.svg";